import { ZodError } from 'zod'

export const getErrorMessage = (error: unknown, fallbackMessage: string) => {
  if (typeof error === 'string') {
    return error
  }

  if (error instanceof Error || error instanceof ZodError) {
    return error.message
  }

  return fallbackMessage
}
